<template>
  <div class="accountManagement">
    <header>
      <!-- <el-button type="primary" style="margin-right: 30px;" @click="adddata">新增</el-button> -->
      <el-input
        v-model="callrecordquery.called"
        style="max-width: 200px; margin-right: 18px"
        placeholder="请输入被叫号"
      />
      <el-select
        v-model="callrecordquery.status"
        placeholder="选择状态"
        clearable
        style="width: 120px;margin-right: 10px;"
        class="filter-item"
      >
        <el-option
          v-for="item in methodOptions"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="wechatSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="wechatReset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="selectData.list"
        border
        style="width: 100%"
      >
        <!-- <el-table-column prop="id" label="id" min-width="100" /> -->
        <el-table-column
          prop="template_id"
          label="模板id"
          min-width="150"
        />
        <el-table-column
          prop="called"
          label="被叫号"
          min-width="180"
        />
        <el-table-column
          prop="called_display"
          label="被叫显号"
          min-width="150"
        />
        <el-table-column
          prop="description"
          label="呼叫详细说明"
          min-width="150"
        />
        <!-- <el-table-column prop="platform_name" label="平台" min-width="150" />
        <el-table-column prop="novel_name" label="小说" min-width="150" />
        <el-table-column prop="lead" label="主角" min-width="100" /> -->

        <el-table-column
          prop="created_at"
          label="发送时间"
          min-width="150"
        />
        <el-table-column
          prop="status"
          label="运行状态"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-show="scope.row.status === 1">{{ scope.row.status_str }}</el-tag>
            <el-tag
              v-show="scope.row.status === 2"
              type="info"
            >{{ scope.row.status_str }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <pagination-right
      :total="selectData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <global-window
      title="授权"
      :visible.sync="dialogVisible"
      :show="true"
      width="1000px"
      @close="closeDialog"
      @confirm="closeDialog"
    >
      <iframe
        v-if="iframeURL === null ? false : true"
        width="960"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </global-window>
    <add-account-drawer ref="addAccountDrawer" />

    <el-dialog
      :width="'30%'"
      title="编辑小程序"
      :visible.sync="dialogFormVisible"
      @close="close"
    >
      <wechat-Form
        ref="wechatform"
        @updata="updata"
      />
      <!-- <el-form ref="downloadquery" label-width="180px" :model="downloadquery">
        <el-form-item label="开始时间1">
          <el-date-picker
            v-model="downloadquery.start_date"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="downloadquery.end_date"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="颜色选择">
          <div class="block">
            <el-color-picker v-model="downloadquery.key_word_color" color-format="hex" />
          </div>
        </el-form-item>
        <div style="padding-left: 330px;">
          <el-button type="primary" @click="sumbitdown">确定</el-button>
        </div>

      </el-form> -->

    </el-dialog>
  </div>
</template>

<script>
import { getList, modify, getURL, getwechat, deletewechat, getcallrecord } from '@/api/report/accountManagement'
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import addAccountDrawer from '@/views/report/WeChatAccountFans/components/accountOfficialdrawer.vue'
import wechatForm from '@/views/wechatApplet/components/wechantform.vue'
export default {
  name: 'InstantCall',
  components: {
    PaginationRight,
    GlobalWindow,
    addAccountDrawer,
    wechatForm
  },
  data() {
    return {
      query: '', // 空是新增 有id是编辑
      tableData: {},
      flag: false,
      authorizeURL: null,
      wechatAccountsQuery: {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      },
      wechatAppletquery: {
        name: '',
        page: 1,
        page_size: 10
      },
      callrecordquery: {
        called: null,
        status: null,
        page: 1,
        page_size: 10
      },
      methodOptions: [
        {
          label: '成功',
          key: 1
        },
        {
          label: '失败',
          key: 2
        }
      ],
      selectData: {}, // 列表数据，包括筛选条件数据
      loading: null, // 加载效果
      iframeURL: null,
      dialogFormVisible: false,
      dialogVisible: false
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (!newValue) {
        this.iframeURL = null
      }
    }
  },
  created() {
    // this.getListData()
    // this.getweichatlist()
    this.getcallrecordlist()
  },
  methods: {
    // 新获取
    getcallrecordlist() {
      this.loading = true
      getcallrecord(this.callrecordquery).then(res => {
        console.log('res7777', res)
        this.selectData = res.data
        this.loading = false
      })
    },
    updata() {
      this.getweichatlist()
      this.dialogFormVisible = false
    },
    // 获取小程序列表
    getweichatlist() {
      this.loading = true
      getwechat(this.wechatAppletquery).then(res => {
        console.log('res', res)
        this.selectData = res.data
        this.loading = false
      })
    },
    // 搜索
    wechatSearch() {
      this.getcallrecordlist()
    },
    // 重置
    wechatReset() {
      this.callrecordquery = {
        called: null,
        status: null,
        page: 1,
        page_size: 10
      }
      this.getcallrecordlist()
    },
    // 关闭弹窗
    close() {
      setTimeout(() => {
        this.$refs.wechatform.qudiao()
      }, 0)
    },
    // 添加
    adddata() {
      setTimeout(() => {
        this.$refs.wechatform.add()
      }, 0)
      this.dialogFormVisible = true
    },
    // 编辑
    wechatedit(id) {
      setTimeout(() => {
        this.$refs.wechatform.edittwi(id)
      }, 0)
      console.log(id)
      // if (this.$refs.wechatform) {
      //   this.$nextTick(() => {
      //     this.$refs.wechatform.edittwi(id)
      //   })
      // }
      this.dialogFormVisible = true
    },
    // 删除
    async deleteone(id) {
      await deletewechat(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      await this.getweichatlist()
    },
    // 获取列表数据，包括筛选条件列表1
    getListData() {
      this.loading = true
      getList(this.wechatAccountsQuery).then(res => {
        this.selectData = res.data
        this.loading = false
      })
    },
    // 跳转到授权页面
    getURLData() {
      this.dialogVisible = true
      getURL().then(res => {
        this.iframeURL = res.data.wechat
        // window.open(res.data)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.iframeURL = null
    },
    // 搜索小说
    handleSearch() {
      this.getListData()
    },
    // 重置搜索框
    handleReset() {
      this.wechatAccountsQuery = {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      }
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.callrecordquery.page_size = e
      this.getcallrecordlist()
    },
    fetchCurrentPage(e) {
      this.callrecordquery.page = e
      this.getcallrecordlist()
    },
    // 发送辑数据请求
    getConfirmData(id, form) {
      modify(id, form).then(res => {
        this.getListData()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.accountManagement {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
